import { Injectable, inject } from '@angular/core';
import { CompanyUsersService } from '../services/company-users.service';
import { AutomationsStore } from '../../features/automations/store/automations.store';
import { CardDetailsStore } from '../../features/cards/stores/card-details.store';
import { CardsStore } from '../../features/cards/stores/cards.store';
import { AssignedCommentsStore } from '../../features/assigned-comments/store/assigned-comments.store';
import { WhatsAppSettingsStore } from '../../features/company-communication/store/whatsapp-settings.store';
import { CustomFieldsFacade } from '../../features/custom-fields/store/custom-fields.facade';
import { InboxStore } from '../../features/inbox/store/inbox.store';
import { MyTasksStore } from '../../features/my-tasks/store/my-tasks.store';
import { NotificationsStore } from '../../features/notifications/store/notifications.store';
import { ProjectsStore } from '../../features/projects/stores/projects.store';
import { WorkflowItemsService } from '../../features/workflows/services/workflow-items.service';
import { WorkflowsStore } from '../../features/workflows/stores/workflows.store';
import { SidebarStore } from '../../layout/sidebar/store/sidebar.store';

@Injectable({ providedIn: 'root' })
export class CompanyScopeResetService {
  private readonly projectsStore = inject(ProjectsStore);
  private readonly workflowsStore = inject(WorkflowsStore);
  private readonly workflowItemsService = inject(WorkflowItemsService);
  private readonly cardsStore = inject(CardsStore);
  private readonly cardDetailsStore = inject(CardDetailsStore);
  private readonly customFieldsFacade = inject(CustomFieldsFacade);
  private readonly automationsStore = inject(AutomationsStore);
  private readonly sidebarStore = inject(SidebarStore);
  private readonly inboxStore = inject(InboxStore);
  private readonly myTasksStore = inject(MyTasksStore);
  private readonly assignedCommentsStore = inject(AssignedCommentsStore);
  private readonly notificationsStore = inject(NotificationsStore);
  private readonly whatsAppSettingsStore = inject(WhatsAppSettingsStore);
  private readonly companyUsers = inject(CompanyUsersService);

  resetForCompanyChange(): void {
    this.companyUsers.reset();
    this.projectsStore.reset();
    this.workflowsStore.reset();
    this.workflowItemsService.reset();
    this.cardsStore.reset();
    this.cardDetailsStore.reset();
    this.customFieldsFacade.reset();
    this.automationsStore.reset();
    this.sidebarStore.resetSidebar();
    this.inboxStore.reset();
    this.myTasksStore.reset();
    this.assignedCommentsStore.reset();
    this.notificationsStore.reset();
    this.whatsAppSettingsStore.reset();
  }
}
